// Import model
import { StartProjectAddFpRoomRequest } from '../models/StartProjectAddFpRoomRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAddFpRoomRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAddFpRoomRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAddFpRoomRequest instance
   */
  static deserialize(json: string): StartProjectAddFpRoomRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAddFpRoomRequest instance
   */
  static fromObject(obj: any): StartProjectAddFpRoomRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAddFpRoomRequest');
    }


    const instance: StartProjectAddFpRoomRequest = {
      leadId: obj['LeadId'] as string | undefined,
      workOrderId: obj['WorkOrderId'] as string | undefined,
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAddFpRoomRequest instances
   */
  static deserializeArray(json: string): StartProjectAddFpRoomRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAddFpRoomRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAddFpRoomRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAddFpRoomRequest instance to a plain object
   */
  static toObject(instance: StartProjectAddFpRoomRequest): any {
    return {
      'LeadId': instance.leadId,
      'WorkOrderId': instance.workOrderId,
      'Name': instance.name,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectAddFpRoomRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAddFpRoomRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
